<template>
  <div class="wrapper">
    <div class="header">
      <admin-title :title="$route.meta.name"></admin-title>
      <span>
        <el-button
          @click="$router.back()"
          type="info"
          icon="el-icon-back"
          size="mini"
          circle
        ></el-button>
      </span>
    </div>

    <el-form ref="form" disabled :model="formData" label-width="80px">
      <el-form-item label="规则名称" prop="ruleName">
        <el-input
          style="width: 400px"
          size="small"
          v-model="formData.ruleName"
          placeholder=""
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="命中分值" prop="hitScore">
        <el-input
          style="width: 400px"
          size="small"
          v-model="formData.hitScore"
          placeholder=""
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="命中建议" prop="hitSuggest">
        <el-input
          style="width: 400px"
          size="small"
          v-model="formData.hitSuggest"
          placeholder=""
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="规则策略" prop="strategyConfig">
        <div
          @mouseleave="currentIndex = -1"
          class="content"
          v-if="formData.strategyConfig.length > 0"
        >
          <div
            :class="['row', currentIndex == i ? 'active' : '']"
            @mouseenter="changeIndex(i)"
            v-for="(item, i) in formData.strategyConfig"
            :key="i"
          >
            <div class="col">
              <span> {{ item.strategy.strategyName }}</span>
            </div>
            <!-- 输入值 -->
            <div class="col" v-if="item.strategy.elType == 1">
              <span>
                <el-select
                  style="width: 120px; margin-right: 20px"
                  v-model="item.operator"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in dict_operator"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </span>
              <span class="eq" v-if="item.operator == 'between'">
                <el-input
                  v-model="item.hits[0]"
                  style="width: 120px"
                  size="small"
                  placeholder="请输入"
                ></el-input>
                <span style="margin: 0 10px">到</span>
                <el-input
                  v-model="item.hits[1]"
                  style="width: 120px"
                  size="small"
                  placeholder="请输入"
                ></el-input>
              </span>
              <span class="eq" v-else>
                <el-input
                  v-model="item.hits[0]"
                  style="width: 120px"
                  size="small"
                  placeholder="请输入"
                ></el-input>
              </span>
            </div>
            <!-- 枚举值 -->
            <div class="col" v-if="item.strategy.elType == 2">
              <el-checkbox-group
                style="margin-top: 5px"
                v-model="formData.strategyConfig[i].hits"
              >
                <el-checkbox
                  v-for="item in item.strategy.elData"
                  :label="item.value"
                  :key="item.value"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <!-- 用户黑名单 -->
            <div class="col black" v-if="item.strategy.elType == 3">---</div>
            <!-- 门店商品管理 -->
            <div class="col" v-if="item.strategy.elType == 5">
              <StoreGoodsDisplay
                :hits="item.hits"
                v-model="item.strategy.elData"
                :showEdit="false"
              />
            </div>
            <!-- 户籍地管理 -->
            <div class="col" v-if="item.strategy.elType == 6">
              <div class="household-container">
                <span class="operator-section">
                  <el-select
                    style="width: 120px; margin-right: 20px"
                    v-model="item.operator"
                    placeholder="请选择"
                    size="small"
                    disabled
                  >
                    <el-option
                      v-for="item in dict_in_operator"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </span>
                <div class="household-display">
                  <span class="household-list">
                    {{ getHouseholdDisplayText(item.strategy.elData) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col"></div>
          </div>
        </div>
        <div class="empty" v-else>
          <el-empty description="暂无策略"></el-empty>
        </div>
      </el-form-item>
    </el-form>
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import { dict_operator, dict_in_operator } from "@/enum/dict/index.js";
import { getDetailAPI } from "./api";
import { getListByIdsAPI } from "@/views/store/store-goods/api";
import StoreGoodsDisplay from "./StoreGoodsDisplay.vue";

export default {
  name: "ReviewRuleDetail",
  components: {
    StoreGoodsDisplay,
  },
  data() {
    return {
      formData: {
        ruleName: "",
        hitScore: undefined,
        hitSuggest: "",
        strategyConfig: [],
      },
      dict_operator,
      dict_in_operator,
      currentIndex: -1,
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {},
  mounted() {
    if (this.$route.params.id) this.getDetail();
  },

  methods: {
    // 详情
    async getDetail() {
      this.formData = await getDetailAPI(this.$route.params.id);
    },
    changeIndex(i) {
      this.currentIndex = i;
    },
    getHouseholdDisplayText(elData) {
      // 直接显示hits字段的内容
      const hits = this.formData.strategyConfig.find(
        (item) => item.strategy.elData === elData,
      )?.hits;
      if (hits && hits.length > 0) {
        return hits.join("，");
      }
      return "暂无户籍地";
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  .header {
    display: flex;
    justify-content: space-between;
  }
  .el-form {
    .el-form-item__content {
      line-height: 18px;
    }
  }
  .content {
    min-width: 750px;
    max-width: 900px;
    background: #fafafa;
    border-radius: 7px;
    .row {
      display: flex;
      align-items: center;
      padding: 7px 10px;
      justify-content: space-between;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border: none;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
      }
      &:first-child {
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
      }
      .col {
        &:first-child {
          width: 200px;
          padding-right: 10px;
          font-weight: 600;
          // text-align: right;
        }
        &:nth-child(2) {
          flex: 1;
          display: flex;
          align-items: center;
          .eq {
            display: flex;
            align-items: center;
          }
          .el-checkbox {
            margin-right: 15px;
          }
          .el-checkbox__label {
            padding-left: 5px;
          }
        }
        &:last-child {
          width: 75px;
          padding-left: 10px;
        }
      }
      .black {
        justify-content: center;
      }
      .household-container {
        display: flex;
        align-items: center;
        width: 100%;
        .operator-section {
          flex-shrink: 0;
        }
        .household-display {
          flex: 1;
          margin-left: 10px;
        }
      }
      .household-display {
        display: flex;
        align-items: center;
        .household-list {
          flex: 1;
          margin-right: 10px;
        }
      }
    }
    .active {
      background-color: #ebeef5;
    }
  }
  .add {
    width: 900px;
    text-align: center;
    margin-top: 20px;
  }
  .empty {
    width: 900px;
    display: flex;
    justify-content: center;
    .el-empty {
      padding: 0;
    }
  }
  .el-dialog {
    .el-dialog__body {
      padding-top: 0;
    }
    .el-radio__inner {
      transform: scale(1.3);
    }
  }
  .el-table {
    // max-height: 400px;
    overflow-y: scroll;
    .el-radio__label {
      display: none;
    }
    &::before {
      display: none;
    }
  }

  .el-table--border {
    border-bottom: 1px solid #fff !important;
  }
  .el-table__cell {
    padding: 8px 0;
  }
}
</style>
